import { motion } from "framer-motion";
import { Target, Eye, Users2, Hammer } from "lucide-react";

const items = [
  {
    title: "Who We Are",
    text: "Impact Together is a purpose-driven consultancy dedicated to driving sustainable development through *collaborative strategy and on-ground execution*. We work across public, private, and civil society sectors.",
    icon: Target,
    color: "from-primary to-secondary",
  },
  {
    title: "Vision",
    text: "A future where cross-sector collaboration powers real progress toward social equity, environmental resilience, and system-wide transformation.",
    icon: Eye,
    color: "from-secondary to-pink-400",
  },
  {
    title: "Mission",
    text: "To build bridges between governments, development actors, businesses, and funders — creating inclusive, scalable, and community-rooted solutions.",
    icon: Users2,
    color: "from-pink-400 to-primary",
  },
  {
    title: "What we do",
    text: "From policy implementation to capacity building, from CSR strategy to grassroots program design — we work across levels to align vision, execution, and impact.",
    icon: Hammer,
    color: "from-pink-400 to-primary",
  },
];

const PurposeVisionMission = () => {
  return (
    <section className="py-8 bg-gradient-to-b from-blue-50 via-white to-white">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-4xl font-heading font-extrabold text-primary mb-12 relative inline-block">
          Why We Exist
          <span className="block h-1 w-24 bg-gradient-to-r from-primary via-secondary to-pink-400 mx-auto mt-3 rounded-full" />
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {items.map((item, index) => (
            <motion.div
              key={item.title}
              className="rounded-3xl p-8 bg-white/80 backdrop-blur-md border border-white/30 shadow-xl transition-transform duration-300 hover:scale-[1.03]"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6, type: "spring" }}
              viewport={{ once: true }}
            >
              {/* Icon with glow gradient circle */}
              <div className="mb-5 flex justify-center">
                <div
                  className={`w-16 h-16 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center shadow-[0_0_24px_rgba(139,92,246,0.2)]`}
                >
                  <item.icon className="text-white w-7 h-7" strokeWidth={2} />
                </div>
              </div>
              <h3 className="text-xl font-semibold font-heading text-primary mb-3">
                {item.title}
              </h3>
              <p className="text-gray-700 text-md font-body leading-relaxed">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PurposeVisionMission;
